"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentPromotionBaseToJSON = exports.ContentPromotionBaseFromJSONTyped = exports.ContentPromotionBaseFromJSON = exports.instanceOfContentPromotionBase = void 0;
var runtime_1 = require("../runtime");
var ContentPromotionBaseAllOfImages_1 = require("./ContentPromotionBaseAllOfImages");
/**
 * Check if a given object implements the ContentPromotionBase interface.
 */
function instanceOfContentPromotionBase(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfContentPromotionBase = instanceOfContentPromotionBase;
function ContentPromotionBaseFromJSON(json) {
    return ContentPromotionBaseFromJSONTyped(json, false);
}
exports.ContentPromotionBaseFromJSON = ContentPromotionBaseFromJSON;
function ContentPromotionBaseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'images': !(0, runtime_1.exists)(json, 'images') ? undefined : (json['images'].map(ContentPromotionBaseAllOfImages_1.ContentPromotionBaseAllOfImagesFromJSON)),
    };
}
exports.ContentPromotionBaseFromJSONTyped = ContentPromotionBaseFromJSONTyped;
function ContentPromotionBaseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'images': value.images === undefined ? undefined : (value.images.map(ContentPromotionBaseAllOfImages_1.ContentPromotionBaseAllOfImagesToJSON)),
    };
}
exports.ContentPromotionBaseToJSON = ContentPromotionBaseToJSON;
